<script>
import PagenationContainer from "@/components/common/PagenationContainer.vue";

export default {
  components: {
    PagenationContainer
  },
  props: {
    purchaseHistorList: Array,
    sourceData: Object,
    agentId: String,
  },
  data() {
    const pageCount = this.sourceData.totalPages;
    return {
      checkBoxSelect: true,
      closePayment: false,
      defaultValue: {},
      pageCount,
      activePage: this.sourceData.number + 1,
      exporting: false
    };
  },
  methods: {
    pageClick(page) {
      this.encodeToUrl({
        page: page
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      if(!val) val = 1;
      this.activePage = val;
      let params = {
        page: this.activePage - 1
      };
      this.$emit("handleCurrentChange", "purchaseHistorList", params);
    },
    async onSwitchCHange(row, value) {
      console.log(row, value);
      this.$confirm("你确定修改吗?", "支付状态改为已到账后将不可更改", {
        confirmButtonText: "确定",
        showCancelButton: false,
        center: true,
        customClass: "paymentConfirmClass"
      }).then(async () => {
          row.payment = row.tempPayment;
          const result = await this.$http.setAgentPurchasePaymentById(row.id);
          if (result === "success") {
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          }
        })
        .catch(() => {
          row.tempPayment = row.payment;
        });
    },
    onClosePayment(formdata, type, row) {
      this.defaultValue = {};
      console.log(formdata, type, row);
    },
    async onExport() {
      if (this.exporting) {
        return;
      }
      this.exporting = true;
      try {
        const result = await this.$http.exportAgentPurchase({
          agentId: this.agentId
        });
        if (!result) {
          this.$message.warning("导出失败，请重试");
          return;
        }
        const link = document.createElement("a");
        const blob = new Blob([result], {
          type: "application/vnd.ms-excel"
        });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `购买历史.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (e) {
        console.error("导出购买历史出错:", e);
      } finally {
        this.exporting = false;
      }
    }
  }
};
</script>

<template>
  <div class="AgentDetailPurchaseHistoryIndex">
    <DialogForm
      v-if="closePayment"
      formTitle="支付状态改为已到账后将不可更改，你确定修改吗？"
      @close="closePayment = false"
      @submitForm="onClosePayment"
      :defaultValue="defaultValue"
      confirmButton="确认"
    />
    <el-button
      type="primary"
      size="mini"
      class="exportButton"
      :loading="exporting"
      @click="onExport"
    >导出</el-button>
    <el-table
      :data="purchaseHistorList"
      class="AgencyAccountTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="createdAt" align="left" label="购买日期" min-width="100"></el-table-column>
      <el-table-column prop="operatorName" align="left" label="操作人" min-width="100"></el-table-column>
      <el-table-column prop="operateType" align="left" label="操作" min-width="50"></el-table-column>
      <el-table-column prop="category" align="left" label="类型" min-width="50"></el-table-column>
      <el-table-column prop="quantity" align="left" label="数量" min-width="40"></el-table-column>
      <el-table-column prop="remark" align="left" label="备注" min-width="100"></el-table-column>
      <el-table-column prop="unitPrice" align="left" label="应支付金额(元)" min-width="100"></el-table-column>
      <el-table-column prop="payment" align="left" label="支付状态">
        <template slot-scope="scope">
          <el-switch
            active-color="#D3D3D3"
            inactive-color="#00c1de"
            v-model="scope.row.tempPayment"
            :disabled="scope.row.payment"
            @change="onSwitchCHange(scope.row)"
          ></el-switch>
          <span v-if="scope.row.payment">已到账</span>
          <span v-else>未到账</span>
        </template>
      </el-table-column>
    </el-table>
    <PagenationContainer >
      <el-pagination
        @size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.AgentDetailPurchaseHistoryIndex {
  .exportButton {
    margin: 20px 2% 0;
    background-color: #00c1de;
    border-color: #00c1de;
  }
  .AgencyAccountTable {
    margin: 20px 2%;
    border: 1px;
    width: 97%;
    .checkBoxLabel {
      color: #303133;
      .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: #303133;
      }
    }
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
  }
}
.paymentConfirmClass {
  .el-message-box__content {
    font-size: 18px;
    color: #303133;
  }
  .el-button--small,
  .el-button--small.is-round {
    width: 90%;
    height: 35px;
    font-size: 14px;
    background-color: #00c1de;
    border-color: #00c1de;
  }
  border-radius: 12px;
}
</style>





// WEBPACK FOOTER //
// src/components/Agent/PurchaseHistory.vue